/**
 * Carimbo de build injetado em tempo de build pelo CI (scripts/ci-build-image.sh
 * → frontend/Dockerfile → ENV VITE_BUILD_*). Garante que o build realmente
 * deployado seja sempre visível (SHA + data), independente da curadoria do
 * changelog — diagnóstico objetivo de "o que está no ar". Em build local, cai
 * em 'dev'/''.
 *
 * Desde a TASK-11670 o sha é o do commit que COMPILOU o frontend, que pode ser
 * anterior ao deploy: o CI reusa a imagem quando frontend/ não mudou. Por isso o
 * rótulo diz "frontend", e o sha do deploy é o `build_sha` do /health.
 */
export const BUILD_SHA: string = import.meta.env.VITE_BUILD_SHA || 'dev'
export const BUILD_TIME: string = import.meta.env.VITE_BUILD_TIME || ''

/** Rótulo legível p/ tooltip: "frontend a1b2c3d · 18/06/2026 17:09". */
export function buildStamp(): string {
  let when = ''
  if (BUILD_TIME) {
    const d = new Date(BUILD_TIME)
    if (!Number.isNaN(d.getTime())) when = ` · ${d.toLocaleString('pt-BR')}`
  }
  return `frontend ${BUILD_SHA}${when}`
}
